import React, { useState } from 'react';
import MemoryGame from './MemoryGame';
import WhackAMole from './WhackAMole';
import GuessTheNumber from './GuessTheNumber';
import SlidingPuzzle from './SlidingPuzzle';
import './App.css';

export default function App() {
  const [currentGame, setCurrentGame] = useState('menu');

  // Menú principal con todos los juegos
  if (currentGame === 'menu') {
    return (
      <div className="menu-container">
        <div className="menu-card">
          <img src={require('./mediavisual-logo.png')} alt="MiniGames Hub" className="logo-image" />
          <p className="menu-subtitle">Selecciona un juego para jugar</p>

          <div className="games-grid">
            <button
              onClick={() => setCurrentGame('memory')}
              className="game-button"
            >
              <div className="game-icon">🧠</div>
              <div className="game-name">Memory Game</div>
              <div className="game-desc">Encuentra las parejas</div>
            </button>

            <button
              onClick={() => setCurrentGame('whack')}
              className="game-button"
            >
              <div className="game-icon">🔨</div>
              <div className="game-name">Whack-a-Mole</div>
              <div className="game-desc">¡Golpea los topos!</div>
            </button>

            <button
              onClick={() => setCurrentGame('guess')}
              className="game-button"
            >
              <div className="game-icon">🎯</div>
              <div className="game-name">Adivina el Número</div>
              <div className="game-desc">¿Cuál es el número?</div>
            </button>

            <button
              onClick={() => setCurrentGame('puzzle')}
              className="game-button"
            >
              <div className="game-icon">🧩</div>
              <div className="game-name">Puzzle Deslizable</div>
              <div className="game-desc">Ordena las fichas</div>
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Memory Game
  if (currentGame === 'memory') {
    return (
      <div>
        <button 
          onClick={() => setCurrentGame('menu')}
          className="back-button"
        >
          ← Volver al menú
        </button>
        <MemoryGame />
      </div>
    );
  }

  // Whack-a-Mole
  if (currentGame === 'whack') {
    return (
      <div>
        <button 
          onClick={() => setCurrentGame('menu')}
          className="back-button"
        >
          ← Volver al menú
        </button>
        <WhackAMole />
      </div>
    );
  }

  // Guess the Number
  if (currentGame === 'guess') {
    return (
      <div>
        <button 
          onClick={() => setCurrentGame('menu')}
          className="back-button"
        >
          ← Volver al menú
        </button>
        <GuessTheNumber />
      </div>
    );
  }

  // Sliding Puzzle
  if (currentGame === 'puzzle') {
    return (
      <div>
        <button 
          onClick={() => setCurrentGame('menu')}
          className="back-button"
        >
          ← Volver al menú
        </button>
        <SlidingPuzzle />
      </div>
    );
  }
}